const STORAGE_KEY = 'policybot_domains_cache_v1';

let memoryCache = null;
let inFlightRequest = null;

const readStorage = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : null;
  } catch {
    return null;
  }
};

const writeStorage = (domains) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(domains));
  } catch {
    // Ignore storage write failures.
  }
};

export const getCachedPolicyBotDomains = () => {
  if (Array.isArray(memoryCache)) return memoryCache;
  const stored = readStorage();
  if (stored) {
    memoryCache = stored;
    return stored;
  }
  return null;
};

export const setCachedPolicyBotDomains = (domains) => {
  if (!Array.isArray(domains)) return;
  memoryCache = domains;
  writeStorage(domains);
};

export const clearPolicyBotDomainCache = () => {
  memoryCache = null;
  inFlightRequest = null;
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // Ignore storage delete failures.
  }
};

export const fetchPolicyBotDomainsOnce = async (backendURL) => {
  const cached = getCachedPolicyBotDomains();
  if (cached) return cached;

  if (inFlightRequest) return inFlightRequest;

  inFlightRequest = (async () => {
    const res = await fetch(`${backendURL}/policybot/domains/`, {
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
    });

    if (!res.ok) {
      throw new Error(`Failed to fetch domains: ${res.status}`);
    }

    const data = await res.json();
    if (!Array.isArray(data)) {
      throw new Error('Invalid domains response');
    }

    setCachedPolicyBotDomains(data);
    return data;
  })();

  try {
    return await inFlightRequest;
  } finally {
    inFlightRequest = null;
  }
};
